import { Portal } from '@toggle/design-system';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EXPANDED_VALUE } from '~/components/expandable-drawer/ExpandableDrawer';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { AlertsInsightCard } from '~/modules/alerts-card/components/alerts-insight-card/AlertsInsightCard';
import { queryKeys, queryValues } from '~/routes/query-params';
import { useSubscription } from '~/stores/use-subscription/useSubscription';

import styles from './TrackingToast.module.scss';

export interface TrackingToastContentProps {
  insightId: string;
}

export const TrackingToastContent = ({
  insightId,
}: TrackingToastContentProps) => {
  const { t } = useTranslation('insights');
  const { params } = useQueryParams();
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );

  const isExpanded = params[queryKeys.drawerExpanded] === EXPANDED_VALUE;
  const relation = params[queryKeys.insightRelation];
  const isSimpleDrawer =
    params[queryKeys.activeDrawer] === queryValues.insightsDrawer;
  const isBannerVisible = isSimpleDrawer && !isBasicOrLightUser && !isExpanded;
  const isNarrowDrawer = isSimpleDrawer && isBasicOrLightUser && !isExpanded;

  return (
    <Portal>
      <div
        className={clsx(styles.toastPositioner, {
          [styles.expanded]: isExpanded,
          [styles.withBanner]: isBannerVisible,
          [styles.narrowDrawer]: isNarrowDrawer,
        })}
      >
        <div className={styles.toastRoot} data-testid="tracking-toast">
          <AlertsInsightCard
            alertEvent={{
              source_id: insightId,
              title: t('insights:drawer.trackingConfirmation'),
              relation: relation ?? undefined,
            }}
            variant="toast"
          />
        </div>
      </div>
    </Portal>
  );
};
